export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp"
}
export enum OngoingABTests {
    MULTILEAD_TINDER = "multilead-tinder",
    USP_LISTING_TILE = "rp-tile-usp"
}
